import React from 'react';

import { ReactComponent as Venmo} from '../../../../assets/svgs/VENMO.svg';
import { ReactComponent as Paypal} from '../../../../assets/svgs/PAYPAL.svg';
import { ReactComponent as Amazon} from '../../../../assets/svgs/AMAZON.svg';
import { ReactComponent as Gas} from '../../../../assets/svgs/GAS_STATION.svg';
import { ReactComponent as GreenDot} from '../../../../assets/svgs/GREEN_DOT.svg';
import { ReactComponent as WholeFoods} from '../../../../assets/svgs/WHOLE_FOODS.svg';
import { ReactComponent as ATM} from '../../../../assets/svgs/ATM.svg';
import { ReactComponent as UBER} from '../../../../assets/svgs/UBER.svg';
import { ReactComponent as Restaurant} from '../../../../assets/svgs/Restaurant.svg';

import styled from 'styled-components';

const BrandContainer = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  margin-top: 28px;
  margin-left: 20px;
`;

const StyledAmazon = styled(Amazon)`
  width: 137px;
  height: 41px;
`;

const StyledGD = styled(GreenDot)`
  width: 74px;
  height: 74px;
`;

const StyledVenmo = styled(Venmo)`
  width: 141px;
  height: 26px;
`;

const StyledWF = styled(WholeFoods)`
  width: 97px;
  height: 66px;
`;

function BrandSection({
  currRoute
}) {

  const renderBrand = () => {
    let brand = '';

    switch(currRoute) {
      case 'amazon': brand = <StyledAmazon />;
      break;

      case 'venmo': brand = <StyledVenmo />;
      break;

      case 'paypal': brand = <Paypal />;
      break;

      case 'gas_station': brand = <Gas />;
      break;

      case 'green_dot': brand= <StyledGD />;
      break;

      case 'whole_foods': brand= <StyledWF />;
      break;

      case 'atm': brand = <ATM />;
      break;

      case 'uber': brand = <UBER />;
      break;

      case 'restaurant': brand = <Restaurant />;
      break;

      default:
      return;
    }

    return brand;
  }

  return (
    <BrandContainer>
     { renderBrand() }
    </BrandContainer>
  );
}

export default BrandSection;